<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">CONFIGURAÇÕES</li>
                </ol>

                <div class="col-md-3">

                </div>

                <div class="col-md-9" v-if="config">


                    <form class="form-horizontal" >

                        <div class="panel panel-info">
                            <div class="panel-heading">RADIUS</div>
                            <div class="panel-body" >

                                <div class="form-group">
                                    <div class="col-sm-3">
                                        <label for="porta" class="control-label">PORTA:</label>
                                        <input id="porta" type="text" v-model.number="config.radius.port" class="form-control" >
                                    </div>
                                    <div class="col-sm-3">
                                        <label for="senha" class="control-label">SENHA:</label>
                                        <input id="senha" type="text" v-model="config.radius.secret" class="form-control" >
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="panel panel-info">
                            <div class="panel-heading">GERENCIANET</div>
                            <div class="panel-body" >

                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <label for="client_id" class="control-label">CLIENT ID:</label>
                                        <input id="client_id" type="text" v-model="config.gerencianet.client_id" class="form-control" >
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <label for="client_secret" class="control-label">CLIENT SECRET:</label>
                                        <input id="client_secret" type="text" v-model="config.gerencianet.client_secret" class="form-control" >
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-3">
                                        <label for="sandbox" class="control-label">SANDBOX:</label>
                                        <select id="sandbox" v-model="config.gerencianet.sandbox" class="form-control" >
                                            <option :value="true">SIM</option>
                                            <option :value="false">NÃO</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-info">
                            <div class="panel-heading">LINK INTERNET</div>
                            <div class="panel-body" >

                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <label for="link_total" class="control-label">TOTAL DA MINHA BANDA (MB):</label>
                                        <input id="link_total" type="text" v-model.number="config.link_total" class="form-control" >
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <label for="download_bloqueio" class="control-label">DOWNLOAD QUANDO BLOQUEADO (KB):</label>
                                        <input id="download_bloqueio" type="text" v-model.number="config.speed_bloqueio.download" class="form-control" >
                                    </div>
                                    <div class="col-sm-6">
                                        <label for="upload_bloqueio" class="control-label">UPLOAD QUANDO BLOQUEADO (KB):</label>
                                        <input id="upload_bloqueio" type="text" v-model.number="config.speed_bloqueio.upload" class="form-control" >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-info">
                            <div class="panel-heading">CGNAT</div>
                            <div class="panel-body" >

                                <div class="form-group">
                                    <div class="col-md-12">
                                        <label for="cgnat_url" class="control-label">URL SERVER:</label>
                                        <input id="cgnat_url" placeholder="https://127.0.0.1:5000" type="text" v-model="config.cgnat.url" class="form-control" >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-info">
                            <div class="panel-heading">ICINGA SERVER</div>
                            <div class="panel-body" >

                                <div class="form-group">
                                    <div class="col-md-12">
                                        <label for="uri" class="control-label">URI SERVER:</label>
                                        <input id="uri" placeholder="https://127.0.0.1:5665" type="text" v-model="config.icinga_api.uri" class="form-control" >
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-6 col-lg-6">
                                        <label for="username" class="control-label">USUÁRIO:</label>
                                        <input id="username" type="text" v-model="config.icinga_api.username" class="form-control" >
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <label for="password" class="control-label">SENHA:</label>
                                        <input id="password" type="text" v-model="config.icinga_api.password" class="form-control" >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="col-sm-10">
                                <button type="button" @click="send()" class="btn btn-success">SALVAR CONFIGURAÇÃO</button>
                            </div>
                        </div>

                    </form>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { Config } from "../../class/config";
/* global swal */
export default {
    data() {
        return {
            config: null
        };
    },
    async beforeMount() {
        this.config = await Config.get();
    },
    methods: {
        send() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar a configuração?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Config
                                .saveGestor(this.config)
                                .then(() => {
                                    swal({
                                        type: "success",
                                        title: "Configuração salva com sucesso!"
                                    });
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
